import { render, staticRenderFns } from "./ImageDialog.vue?vue&type=template&id=24fa4393"
import script from "./ImageDialog.vue?vue&type=script&lang=ts"
export * from "./ImageDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports